import { action, makeObservable, observable } from 'mobx';

export class PageModalController {
  @observable isActive: boolean = false;

  constructor() {
    makeObservable(this);
  }

  @action open = () => {
    this.isActive = true;
  };

  @action close = () => {
    this.isActive = false;
  };
}
